/**
 * Server only middleware
 * Capture query params in url and store them in cookies, then remove query params from url by doing a redirect
 * (A redirect on server side is a hard reload, you will lose all data prior to the redirect (store, state, ...).
 * To avoid that you can store the data in a cookie)
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;

  const { name, params, query } = to;

  const origin = useCookie("origin");
  const out = useCookie("out");
  const access = useCookie("access");

  if (query.origin || query.out || query.access_token) {
    origin.value = query.origin ? { url: query.origin, external: true } : null;
    out.value = query.out ? query.out : null;
    access.value =
      query.access_token && query.access_expire
        ? {
            token: query.access_token,
            delay: query.delay ? query.delay * 1000 : 3600 * 1000,
            exp: query.access_expire * 1000,
          }
        : null;

    delete query.origin;
    delete query.out;
    delete query.access_token;
    delete query.access_expire;

    return navigateTo({ name, params, query });
  }
});
